import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'src/store';
import { BannerNftsAdapter } from './banner-nfts.adapter';

export const bannerNftsSelect = (state: RootState) => state.features.nfts.bannerNfts;

export const bannerNftsSelectors = BannerNftsAdapter.getSelectors();

export const selectBannerNftsEntities = createSelector(
    bannerNftsSelect,
    (state) => bannerNftsSelectors.selectAll(state)
);

export const selectBannerNftsLoading = createSelector(bannerNftsSelect, (state) =>
    state.isLoading
);
